/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

class ModifyMiniCart {
    constructor() {
        this.selectors = {
            counterUpdater: '[data-mini-cart-counter-update]'
        }
        this.listen();
    }

    listen() {
        document.addEventListener('theme:cart:change', (event) => {
            this.cartCount = event.detail.cartCount;
            this.counts = document.querySelectorAll(this.selectors.counterUpdater);
            this.update();
        });
    }

    update() {
        if (this.cartCount !== null && this.counts) {
            this.counts.forEach((count) => {
                count.innerHTML = this.cartCount;
            });
        }
    }
}



(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

    // new ModifyMiniCart();

})();
